import { Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import React from 'react';
import { InboxContact, User } from 'src/constants/types';
import { ContactListItem } from './ContactListItem';

type ContactProps = {
  contact: InboxContact;
  selectedContact: string | null;
  onSelectChat: (contactId: string, contactPhoneNumber: string) => void;
  users: User[];
};

const formatName = (contact: User): string =>
  contact.firstName || contact.lastName
    ? `${contact.firstName || ''} ${contact.lastName || ''}`.trim()
    : contact.phoneNumber;

const Contact = ({ contact, selectedContact, onSelectChat, users }: ContactProps) => {
  const assignedUser = users.find(user => user.id === contact.contact.assignedTo);

  return (
    <ContactListItem
      selected={contact.contact.id === selectedContact}
      unread={!contact.isChatRead}
      onClick={() => onSelectChat(contact.contact.id, contact.contact.phoneNumber)}
    >
      <Stack spacing={0.3}>
        <Typography variant="subtitle2" fontWeight="fontWeightSemiBold">
          {`${contact.contact.firstName || ''} ${contact.contact.lastName || ''}`.trim()}
        </Typography>
        <Typography variant="caption">{contact.contact.phoneNumber}</Typography>
        {assignedUser && (
          <Typography variant="caption" fontStyle="italic">
            Assigned To: {formatName(assignedUser)}
          </Typography>
        )}
        {contact.lastMessageDate && (
          <Typography variant="caption" color="grey.400" fontSize={10}>
            {dayjs(contact.lastMessageDate).format('YYYY-MM-DD hh:mm A')}
          </Typography>
        )}
      </Stack>
    </ContactListItem>
  );
};

export default Contact;
